/* eslint-disable indent */
/* global $ instantsearch */

import { renderEmpty, renderPagination, renderVoice } from './templates';

class VoiceSearch {
  constructor(searchClient, locale) {
    const _this = this;

    /* The sasaki_locale_terms object is generated by WordPress in locale.php. */
    this.$body = $('body');
    this.locale = locale;
    this.$clearAllButton = $('#js-search-clear-all');
    this.search = instantsearch({
      indexName: 'prod_voices',
      searchClient,
      routing: true,
      searchFunction(helper) {
        helper.search();
        _this.showHideClearButton(helper.state.query);
      },
    });

    this.init();
  }

  init() {
    this.addSearchWidgets();
    this.$clearAllButton.on('click.clearSearch', this.resetSearch);

    this.search.start();
  }

  addSearchWidgets() {
    let placeholder = this.locale === 'zh' ? '搜索' : 'Search Voices';
    let locale = this.locale;

    this.search.addWidget(
      instantsearch.widgets.searchBox({
        container: '#searchbox',
        placeholder: placeholder,
        showLoadingIndicator: false,
        templates: {
          submit: 'Submit search query',
          reset: 'Reset search query',
        },
      }),
    );

    setTimeout(() => {
      this.addAccessibleLabel();
    }, 20);

    this.search.addWidget(
      instantsearch.widgets.currentRefinements({ container: '#current-refinements',
      transformItems(items) {
        return items.map(item => ({
          ...item,
          refinements: item.refinements.map(refinement => ({
            ...refinement,
            label: locale === 'zh' ? (sasaki_locale_terms[refinement.label] ? sasaki_locale_terms[refinement.label] : refinement.label) : refinement.label
            }))
          }))
      }}),
    );

    this.search.addWidget(
      instantsearch.widgets.refinementList({ container: '#sector-list', attribute: 'sector', sortBy: ['name:asc'], limit: 20,
      transformItems(items) {
        return items.map(item => ({
          ...item,
          highlighted: locale === 'zh' ? (sasaki_locale_terms[item.highlighted] ? sasaki_locale_terms[item.highlighted] : item.highlighted) : item.highlighted
        }));
      }}),
    );

    this.search.addWidget(
      instantsearch.widgets.refinementList({ container: '#service-list', attribute: 'service', sortBy: ['name:asc'], limit: 20,
      transformItems(items) {
        return items.map(item => ({
          ...item,
          highlighted: locale === 'zh' ? (sasaki_locale_terms[item.highlighted] ? sasaki_locale_terms[item.highlighted] : item.highlighted) : item.highlighted
        }));
      }}),
    );

    this.search.addWidget(
      instantsearch.widgets.refinementList({ container: '#type-list', attribute: 'type', sortBy: ['name:asc'], limit: 20,
      transformItems(items) {
        return items.map(item => ({
          ...item,
          highlighted: locale === 'zh' ? (sasaki_locale_terms[item.highlighted] ? sasaki_locale_terms[item.highlighted] : item.highlighted) : item.highlighted
        }));
      }}),
    );

    this.search.addWidget(instantsearch.widgets.configure({ hitsPerPage: 24 }));

    const customHits = instantsearch.connectors.connectHits(this.renderHits);
    this.search.addWidget(customHits({
      container: $('#hits'),
      transformItems: items => items.map(item => ({
        ...item,
        locale: this.locale
      })),
    }));

    const customPagination = instantsearch.connectors.connectPagination(renderPagination);
    this.search.addWidget(customPagination({
      container: $('#pagination'),
      padding: 99,
      locale: this.locale
    }));

    this.search.addWidget(
      instantsearch.widgets.clearRefinements({ container: '#clear-refinements' }),
    );

    this.search.on('render', () => {
      const $archiveFeed = this.$body.find('.archive-feed');
      $archiveFeed.removeClass('js-content-is-loaded');

      setTimeout(() => {
        $archiveFeed.addClass('js-content-is-loaded');
      }, 500)
    });
  }

  addAccessibleLabel() {
    const searchInput = $('.ais-SearchBox-input');
    searchInput
      .attr('id', 'algolia-searchbox')
      .prepend(`<label for="algolia-searchbox" class="visually-hidden">Search Input</label>`);
  }

  showHideClearButton(searchQuery) {
    setTimeout(() => {
      if (searchQuery || this.hasFiltersApplied()) {
        this.$clearAllButton.removeClass('visually-hidden');
      } else {
        this.$clearAllButton.addClass('visually-hidden');
      }
    }, 50);
  }

  hasFiltersApplied() {
    const $clearFilterButton = $('#clear-refinements').find('.ais-ClearRefinements-button');
    return $clearFilterButton.length > 0 && !$clearFilterButton.is(':disabled');
  }

  resetSearch() {
    const $clearFilterButton = $('#clear-refinements').find('.ais-ClearRefinements-button');
    const $searchReset = $('#searchbox').find('.ais-SearchBox-reset');
    $clearFilterButton.click();
    $searchReset.click();
  }

  renderHits({ hits, results, widgetParams }) {
    if (results && hits.length === 0) {
      $(widgetParams.container).html(renderEmpty(results.query));
      return;
    }

    $(widgetParams.container).html(
      `${hits
        .map(item => {
          return renderVoice(item, instantsearch, true);
        })
        .join('')}`,
    );
  }

  deinit() {
    this.$clearAllButton.off('click.clearSearch');
  }
}

export default VoiceSearch;
